import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, CrudService, SharedDataService, thisYear } from 'elbuild-ui-lib-core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { VERSION } from 'src/environments/version';
import { Customer } from 'yf-commerce-model-ui-lib';
import { RouteGuardService, ShopCartService, WishlistService } from 'yf-commerce-ui-lib';

import { environment } from '../../environments/environment';
import { SectionsService } from '../shared/services/sections.service';
import { AccountService } from '../shared/services/account.service';

@Component({
	selector: 'app-account',
	templateUrl: './account.component.html',
	styleUrls: ['./account.component.scss'],
	standalone: false
})
export class AccountComponent implements OnInit, OnDestroy {


	public url: any;
	loggedUser: Customer;
	public openDashboard: boolean = false;
	selected: string;

	subsections: any[] = [];
	ismobile: boolean;




	showCards: boolean;

	constructor(private router: Router,
		private sectionsservice: SectionsService,
		private sharedDataService: SharedDataService,
		private accountservice: AccountService,
		protected deviceService: DeviceDetectorService) {

		this.ismobile = this.deviceService.isMobile() || this.deviceService.isTablet();


		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.url = event.url;
				this.selected = this.url.replace('/account/', '');
				this.openDashboard = false;
			}
		});



		this.sharedDataService.currentLoggedUser.subscribe(data => {
			this.loggedUser = data as unknown as Customer;

		});

		this.selected = this.router.url.replace('/account/', '');


		this.sectionsservice.currentSubsections.subscribe((sections: any) => {
			this.subsections = sections;
		})
	}






	ngOnInit(): void {
		// Change color for this layout
		document.documentElement.style.setProperty('--theme-deafult', environment.themecolor);

	}

	ngOnDestroy(): void {
		// Remove Color
		document.documentElement.style.removeProperty('--theme-deafult');
	}

	ToggleDashboard() {
		this.openDashboard = !this.openDashboard;
	}

	logout(): void {
		this.accountservice.logout(true, true);
	}


	get baseURL() {
		return environment.baseURL;
	}


	handleClickSubsection(sub: { title: string, label: string, icon: string, link?: string }) {
		this.selected = sub.title;
		this.sectionsservice.navigateTo(sub);
	}

}
